<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/shooting/mouth/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shezuibianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shezuimingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'id desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_base_shooting_mouth_create')" size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, null, beforeShowEditDialogEdit)" v-if="utils.checkPower('web_base_shooting_mouth_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/web/basic/shooting/mouth/delete')" v-if="utils.checkPower('web_base_shooting_mouth_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shezuibianma')" required>
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shezuimingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" :rows="4" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/basic/shooting/mouth/create')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('shezuibianma')" required>
            <el-input v-model="yt.editObj.code" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('shezuimingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" :rows="4" v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/basic/shooting/mouth/update')" :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>

  </div>
</template>
<script type="text/javascript">

export default {
  name: 'web_base_shooting_mouth_list',
  components: {
  },
  data() {
    return {
      printTemplateLoading: false,
      printTemplates: [],
      importShow: false,
      columns: [
        {
          label: 'shezuibianma',
          prop: 'code'
        },
        {
          label: 'shezuimingcheng',
          prop: 'name'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'id desc'
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 新增之前处理数据
    beforeShowEditDialogInsert(row) {
      return row;
    },

    // 编辑之前处理数据
    beforeShowEditDialogEdit(row) {
      return row;
    },
  }
};
</script>
